import { BaggageInfoEnum, PenaltiesInfoEnum, } from "../common";
import { ShopSymbol } from "../flights";
import { uniq } from "lodash";
export var Assistance;
(function (Assistance) {
    Assistance["WCOB"] = "WCOB";
    Assistance["WCHS"] = "WCHS";
    Assistance["WCBW"] = "WCBW";
    Assistance["STCR"] = "STCR";
    Assistance["WCHC"] = "WCHC";
    Assistance["WCBD"] = "WCBD";
    Assistance["BLND"] = "BLND";
    Assistance["DEAF"] = "DEAF";
    Assistance["WCHR"] = "WCHR";
    Assistance["WCMP"] = "WCMP";
    Assistance["WCLB"] = "WCLB";
})(Assistance || (Assistance = {}));
export var MultiTicketTypeEnum;
(function (MultiTicketTypeEnum) {
    MultiTicketTypeEnum["Single"] = "single";
    MultiTicketTypeEnum["HackerFare"] = "hackerFare";
    MultiTicketTypeEnum["VI"] = "virtualInterline";
})(MultiTicketTypeEnum || (MultiTicketTypeEnum = {}));
export var PriceDropProtectionEnum;
(function (PriceDropProtectionEnum) {
    PriceDropProtectionEnum["IsEligible"] = "IsEligible";
    PriceDropProtectionEnum["NotEligible"] = "NotEligible";
})(PriceDropProtectionEnum || (PriceDropProtectionEnum = {}));
export var PaymentLineItemEnum;
(function (PaymentLineItemEnum) {
    PaymentLineItemEnum["UserCard"] = "UserCard";
    PaymentLineItemEnum["Rewards"] = "Rewards";
    PaymentLineItemEnum["AncillaryCredit"] = "AncillaryCredit";
    PaymentLineItemEnum["TravelWallet"] = "TravelWallet";
})(PaymentLineItemEnum || (PaymentLineItemEnum = {}));
export var PaymentLineItemAncillaryCreditEnum;
(function (PaymentLineItemAncillaryCreditEnum) {
    PaymentLineItemAncillaryCreditEnum["ChfarCredit"] = "ChfarCredit";
})(PaymentLineItemAncillaryCreditEnum || (PaymentLineItemAncillaryCreditEnum = {}));
export var PaymentLineItemTravelWalletEnum;
(function (PaymentLineItemTravelWalletEnum) {
    PaymentLineItemTravelWalletEnum["TravelWalletOffer"] = "TravelWalletOffer";
    PaymentLineItemTravelWalletEnum["TravelWalletCredit"] = "TravelWalletCredit";
})(PaymentLineItemTravelWalletEnum || (PaymentLineItemTravelWalletEnum = {}));
export var CreditEnum;
(function (CreditEnum) {
    CreditEnum["Offer"] = "Offer";
})(CreditEnum || (CreditEnum = {}));
export var PaymentTypeEnum;
(function (PaymentTypeEnum) {
    PaymentTypeEnum["FiatAmountInfo"] = "FiatAmountInfo";
    PaymentTypeEnum["RewardsAmountInfo"] = "RewardsAmountInfo";
    PaymentTypeEnum["SplitAmountInfo"] = "SplitAmountInfo";
})(PaymentTypeEnum || (PaymentTypeEnum = {}));
export var PaymentEnum;
(function (PaymentEnum) {
    PaymentEnum["CreditCard"] = "CreditCard";
})(PaymentEnum || (PaymentEnum = {}));
export var AvailabilityEnum;
(function (AvailabilityEnum) {
    AvailabilityEnum[AvailabilityEnum["Available"] = 0] = "Available";
    AvailabilityEnum[AvailabilityEnum["AvailableAfter"] = 1] = "AvailableAfter";
    AvailabilityEnum[AvailabilityEnum["AvailableUntil"] = 2] = "AvailableUntil";
    AvailabilityEnum[AvailabilityEnum["Unavailable"] = 3] = "Unavailable";
})(AvailabilityEnum || (AvailabilityEnum = {}));
export var Reason;
(function (Reason) {
    Reason[Reason["AlreadyDone"] = 0] = "AlreadyDone";
    Reason[Reason["ContactAirline"] = 1] = "ContactAirline";
    Reason[Reason["ContactSupport"] = 2] = "ContactSupport";
    Reason[Reason["NotAllowed"] = 3] = "NotAllowed";
})(Reason || (Reason = {}));
export var PortalItineraryStatusEnum;
(function (PortalItineraryStatusEnum) {
    PortalItineraryStatusEnum["Canceled"] = "Canceled";
    PortalItineraryStatusEnum["Confirmed"] = "Confirmed";
    PortalItineraryStatusEnum["Modified"] = "Modified";
    PortalItineraryStatusEnum["Pending"] = "Pending";
})(PortalItineraryStatusEnum || (PortalItineraryStatusEnum = {}));
export var ProductVariantEnum;
(function (ProductVariantEnum) {
    ProductVariantEnum["FDA"] = "FDA";
    ProductVariantEnum["FDR"] = "FDR";
    ProductVariantEnum["FDR2"] = "FDR2";
})(ProductVariantEnum || (ProductVariantEnum = {}));
export var DisruptionContractStatusEnum;
(function (DisruptionContractStatusEnum) {
    DisruptionContractStatusEnum["Purchase"] = "Purchase";
    DisruptionContractStatusEnum["Rebook"] = "Rebook";
    DisruptionContractStatusEnum["Refund"] = "Refund";
    DisruptionContractStatusEnum["Remove"] = "Remove";
    DisruptionContractStatusEnum["Cancel"] = "Cancel";
    DisruptionContractStatusEnum["AlreadyExercised"] = "AlreadyExercised";
    DisruptionContractStatusEnum["RebookOnlyEligible"] = "RebookOnlyEligible";
})(DisruptionContractStatusEnum || (DisruptionContractStatusEnum = {}));
export var PolicyDetailsEnum;
(function (PolicyDetailsEnum) {
    PolicyDetailsEnum["FixedPolicyDetails"] = "FixedPolicyDetails";
    PolicyDetailsEnum["PercentagePolicyDetails"] = "PercentagePolicyDetails";
})(PolicyDetailsEnum || (PolicyDetailsEnum = {}));
export var DisruptionProtectionRebookEnum;
(function (DisruptionProtectionRebookEnum) {
    DisruptionProtectionRebookEnum["NotRebook"] = "NotRebook";
    DisruptionProtectionRebookEnum["IsRebook"] = "IsRebook";
})(DisruptionProtectionRebookEnum || (DisruptionProtectionRebookEnum = {}));
export var FlightItinerarySegmentStatusEnum;
(function (FlightItinerarySegmentStatusEnum) {
    FlightItinerarySegmentStatusEnum["Confirmed"] = "Confirmed";
    FlightItinerarySegmentStatusEnum["UnMapped"] = "UnMapped";
    FlightItinerarySegmentStatusEnum["UnMappedPersisted"] = "UnMappedPersisted";
    FlightItinerarySegmentStatusEnum["Pending"] = "Pending";
    FlightItinerarySegmentStatusEnum["Declined"] = "Declined";
    FlightItinerarySegmentStatusEnum["ConfirmedPendingNewChange"] = "ConfirmedPendingNewChange";
    FlightItinerarySegmentStatusEnum["Cancelled"] = "Cancelled";
    FlightItinerarySegmentStatusEnum["Canceled"] = "Canceled";
})(FlightItinerarySegmentStatusEnum || (FlightItinerarySegmentStatusEnum = {}));
export var FlightItineraryState;
(function (FlightItineraryState) {
    FlightItineraryState["Canceled"] = "Canceled";
    FlightItineraryState["Past"] = "Past";
    FlightItineraryState["Future"] = "Future";
    FlightItineraryState["Invalid"] = "Invalid";
    FlightItineraryState["Present"] = "Present";
})(FlightItineraryState || (FlightItineraryState = {}));
export var Gender;
(function (Gender) {
    Gender["F"] = "F";
    Gender["M"] = "M";
})(Gender || (Gender = {}));
export var PassengerTypeEnum;
(function (PassengerTypeEnum) {
    PassengerTypeEnum["AgelessChild"] = "AgelessChild";
    PassengerTypeEnum["LapInfantPrivate"] = "LapInfantPrivate";
    PassengerTypeEnum["LapInfant"] = "LapInfant";
    PassengerTypeEnum["SeatedInfant"] = "SeatedInfant";
    PassengerTypeEnum["AgelessChildPrivate"] = "AgelessChildPrivate";
    PassengerTypeEnum["AdultPrivate"] = "AdultPrivate";
    PassengerTypeEnum["AgeChild"] = "AgeChild";
    PassengerTypeEnum["Adult"] = "Adult";
    PassengerTypeEnum["SeatedInfantPrivate"] = "SeatedInfantPrivate";
})(PassengerTypeEnum || (PassengerTypeEnum = {}));
export var PenaltyEnum;
(function (PenaltyEnum) {
    PenaltyEnum["NoPenalty"] = "NoPenalty";
    PenaltyEnum["NotPossible"] = "NotPossible";
    PenaltyEnum["Unknown"] = "Unknown";
    PenaltyEnum["WithFee"] = "WithFee";
})(PenaltyEnum || (PenaltyEnum = {}));
export var PostTicketingStatus;
(function (PostTicketingStatus) {
    PostTicketingStatus["Canceled"] = "Canceled";
    PostTicketingStatus["Modified"] = "Modified";
    PostTicketingStatus["Rejected"] = "Rejected";
    PostTicketingStatus["Ticketed"] = "Ticketed";
})(PostTicketingStatus || (PostTicketingStatus = {}));
export var TicketNumberTypeEnum;
(function (TicketNumberTypeEnum) {
    TicketNumberTypeEnum["InfantNotIssued"] = "InfantNotIssued";
    TicketNumberTypeEnum["TicketNumber"] = "TicketNumber";
})(TicketNumberTypeEnum || (TicketNumberTypeEnum = {}));
export var TravelCreditStatus;
(function (TravelCreditStatus) {
    TravelCreditStatus["Available"] = "Available";
    TravelCreditStatus["Expired"] = "Expired";
    TravelCreditStatus["Redeemed"] = "Redeemed";
})(TravelCreditStatus || (TravelCreditStatus = {}));
export var TravelItineraryEnum;
(function (TravelItineraryEnum) {
    TravelItineraryEnum["MultiTravelItinerary"] = "MultiTravelItinerary";
    TravelItineraryEnum["SingleTravelItinerary"] = "SingleTravelItinerary";
})(TravelItineraryEnum || (TravelItineraryEnum = {}));
export var getTripSegmentsFromItinerarySegment = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var segment = _a.segment, airportMap = _a.airportMap, airlineMap = _a.airlineMap, useCityName = _a.useCityName;
    var origin = airportMap[segment.origin.locationCode];
    var destination = airportMap[segment.destination.locationCode];
    return {
        cabinClassName: segment.cabinClassName,
        marketingAirline: {
            name: segment.marketingAirline
                ? ((_c = airlineMap[(_b = segment.marketingAirline) === null || _b === void 0 ? void 0 : _b.code]) === null || _c === void 0 ? void 0 : _c.displayName) || ""
                : "",
            code: ((_d = segment.marketingAirline) === null || _d === void 0 ? void 0 : _d.code) || "",
        },
        operatingAirline: {
            name: segment.operatingAirline
                ? ((_f = airlineMap[(_e = segment.operatingAirline) === null || _e === void 0 ? void 0 : _e.code]) === null || _f === void 0 ? void 0 : _f.displayName) || ""
                : "",
            code: ((_g = segment.operatingAirline) === null || _g === void 0 ? void 0 : _g.code) || "",
        },
        airlineCode: segment.marketingAirline.code,
        airlineName: ((_h = airlineMap[segment.marketingAirline.code]) === null || _h === void 0 ? void 0 : _h.displayName) || "",
        flightNumber: "".concat(segment.marketingAirline.flightNumber),
        departureTime: segment.zonedUpdatedDeparture ||
            segment.zonedScheduledDeparture ||
            segment.scheduledDeparture,
        originCode: segment.origin.locationCode,
        originName: (_j = (useCityName ? origin === null || origin === void 0 ? void 0 : origin.cityName : origin === null || origin === void 0 ? void 0 : origin.name)) !== null && _j !== void 0 ? _j : "",
        arrivalTime: segment.zonedUpdatedArrival ||
            segment.zonedScheduledArrival ||
            segment.scheduledArrival,
        destinationCode: segment.destination.locationCode,
        destinationName: (_k = (useCityName ? destination === null || destination === void 0 ? void 0 : destination.cityName : destination === null || destination === void 0 ? void 0 : destination.name)) !== null && _k !== void 0 ? _k : "",
        stops: segment.stops,
        stopoverDurationMinutes: segment.stopoverDurationMinutes,
        isSelfTransferLayover: segment.isSelfTransferLayover,
        plusDays: segment.plusDays,
    };
};
export var getTripSegmentsFromItinerarySegments = function (_a) {
    var segments = _a.segments, airportMap = _a.airportMap, airlineMap = _a.airlineMap, useCityName = _a.useCityName;
    return segments.map(function (segment) {
        return getTripSegmentsFromItinerarySegment({
            segment: segment,
            airportMap: airportMap,
            airlineMap: airlineMap,
            useCityName: useCityName,
        });
    });
};
export var getPlusDaysFromItinerarySegments = function (segments) {
    return segments
        .filter(function (s) { return s.plusDays && s.plusDays > 0; })
        .reduce(function (total, segment) { var _a; return total + ((_a = segment.plusDays) !== null && _a !== void 0 ? _a : 0); }, 0);
};
export var getPlusDays = function (trip) {
    // TODO: confirm with the BE to see whether this is the only way to get plus-days
    return getPlusDaysFromItinerarySegments(trip.segments);
};
export var getItinerarySummaryProps = function (flight, isOutgoing, airportMap, airlineMap, multicitySliceIndex) {
    var tripSlice;
    if (multicitySliceIndex !== undefined) {
        var slices = getSlicesFromTravelItinerary(flight.bookedItinerary.travelItinerary);
        tripSlice = slices[multicitySliceIndex];
    }
    else {
        tripSlice = isOutgoing
            ? getDepartureSlice(flight.bookedItinerary)
            : getReturnSlice(flight.bookedItinerary);
    }
    return getItinerarySummaryPropsFromSlice(tripSlice, airportMap, airlineMap);
};
export var getItinerarySummaryPropsFromSlice = function (tripSlice, airportMap, airlineMap) {
    var _a, _b, _c, _d, _e, _f, _g;
    var plusDays = getPlusDays(tripSlice);
    return {
        tripSlice: tripSlice,
        segments: getTripSegmentsFromItinerarySegments({
            segments: tripSlice.segments,
            airportMap: airportMap,
            airlineMap: airlineMap,
        }),
        departureTime: ((_a = tripSlice.segments[0]) === null || _a === void 0 ? void 0 : _a.zonedUpdatedDeparture) ||
            ((_b = tripSlice.segments[0]) === null || _b === void 0 ? void 0 : _b.zonedScheduledDeparture) ||
            ((_c = tripSlice.segments[0]) === null || _c === void 0 ? void 0 : _c.scheduledDeparture) ||
            "",
        // TODO find out where to get planeInfo and fareClass info
        planeInfo: "",
        fareClass: ((_d = tripSlice.fareShelf) === null || _d === void 0 ? void 0 : _d.shortBrandName) || "",
        plusDays: plusDays,
        arrivalTime: ((_e = tripSlice.segments[0]) === null || _e === void 0 ? void 0 : _e.zonedUpdatedArrival) ||
            ((_f = tripSlice.segments[0]) === null || _f === void 0 ? void 0 : _f.zonedScheduledArrival) ||
            ((_g = tripSlice.segments[0]) === null || _g === void 0 ? void 0 : _g.scheduledArrival) ||
            "",
    };
};
export var getSlicesFromTravelItinerary = function (travelItinerary) {
    switch (travelItinerary === null || travelItinerary === void 0 ? void 0 : travelItinerary.TravelItinerary) {
        case TravelItineraryEnum.SingleTravelItinerary:
            return travelItinerary.slices;
        case TravelItineraryEnum.MultiTravelItinerary:
            return travelItinerary.travelItineraries.flatMap(function (itinerary) {
                return itinerary.slices;
            });
    }
};
export var getDepartureSliceFromTravelItinerary = function (travelItinerary) {
    return getSlicesFromTravelItinerary(travelItinerary)[0];
};
export var isViMultiTicket = function (multiTicketType) {
    return (multiTicketType === MultiTicketTypeEnum.VI ||
        multiTicketType === MultiTicketTypeEnum.HackerFare);
};
export var getSliceFromViMultiTicket = function (bookedItinerary, sliceIndex) {
    return bookedItinerary.travelItinerary.slices[sliceIndex];
};
//  TODO show changed itinerary times if a minor schedule change exists
export var getDepartureSlice = function (bookedItinerary) {
    if (isViMultiTicket(bookedItinerary.multiTicketType)) {
        return getSliceFromViMultiTicket(bookedItinerary, 0);
    }
    return getDepartureSliceFromTravelItinerary(bookedItinerary.travelItinerary);
};
export var getItineraryDepartureDate = function (itinerary) {
    var _a;
    var firstSegment = getDepartureSliceFromTravelItinerary(itinerary).segments[0];
    return (_a = firstSegment.zonedUpdatedDeparture) !== null && _a !== void 0 ? _a : firstSegment.updatedDeparture;
};
export var getReturnSliceFromTravelItinerary = function (travelItinerary) {
    var slices = getSlicesFromTravelItinerary(travelItinerary);
    if (slices.length === 2)
        return slices[1];
    else
        return undefined;
};
// fetch the final slice (leg) the user will travel on. if the itinerary only
// contains one slice then return `undefined`
export var getLastSliceFromTravelItinerary = function (travelItinerary) {
    var slices = getSlicesFromTravelItinerary(travelItinerary);
    if (slices.length > 1)
        return slices[slices.length - 1];
    else
        return undefined;
};
export var getReturnSlice = function (bookedItinerary) {
    if (isViMultiTicket(bookedItinerary.multiTicketType)) {
        return getSliceFromViMultiTicket(bookedItinerary, 1);
    }
    return getReturnSliceFromTravelItinerary(bookedItinerary.travelItinerary);
};
// fetch the final slice (leg) the user will travel on. if the itinerary only
// contains one slice then return `undefined`
export var getLastSlice = function (bookedItinerary) {
    return getLastSliceFromTravelItinerary(bookedItinerary.travelItinerary);
};
export var getMulticitySlice = function (bookedItinerary, sliceIndex) {
    var travelItinerary = bookedItinerary.travelItinerary;
    return travelItinerary.slices[sliceIndex];
};
export var getItineraryReturnDate = function (itinerary) {
    var _a, _b;
    var firstSegment = (_a = getReturnSliceFromTravelItinerary(itinerary)) === null || _a === void 0 ? void 0 : _a.segments[0];
    return (_b = firstSegment === null || firstSegment === void 0 ? void 0 : firstSegment.zonedUpdatedDeparture) !== null && _b !== void 0 ? _b : firstSegment === null || firstSegment === void 0 ? void 0 : firstSegment.updatedDeparture;
};
export var getAirportCodesFromSlice = function (slice) {
    var _a;
    var sliceOriginAirportCode = (_a = slice.segments[0]) === null || _a === void 0 ? void 0 : _a.origin.locationCode;
    var sliceDestinationAirportCode = slice.segments[slice.segments.length - 1].destination.locationCode;
    return [sliceOriginAirportCode, sliceDestinationAirportCode];
};
// true if the itinerary is currently considered a multi-city itinerary, and not categorized as
// oneway or round trip. If a trip was originally booked as a multi-city itinerary but then had
// leg cancellations, it can switch to be considered a oneway or even round trip, itinerary.
// 2-slice multicity trips where the first slice origin city matches the second slice destination city
// and where the first slice destination city matches second slice origin city are treated as round trip itineraries.
// If the multiticketType is VI, we should still treat this itinerary as roundtrip
export var isMultiCityItinerary = function (bookedItinerary, airportMap) {
    if (bookedItinerary.multiTicketType === MultiTicketTypeEnum.VI)
        return false;
    var slices = getSlicesFromTravelItinerary(bookedItinerary.travelItinerary);
    if (slices.length < 2)
        return false;
    if (slices.length === 2) {
        var departureSlice = getDepartureSlice(bookedItinerary);
        var returnSlice = getReturnSlice(bookedItinerary);
        if (!returnSlice)
            return false;
        var _a = getAirportCodesFromSlice(departureSlice), slice1OriginAirportCode = _a[0], slice1DestinationAirportCode = _a[1];
        var _b = getAirportCodesFromSlice(returnSlice), slice2OriginAirportCode = _b[0], slice2DestinationAirportCode = _b[1];
        var slice1OriginServedCityName = airportMap[slice1OriginAirportCode].servedCityName;
        var slice1DestinationServedCityName = airportMap[slice1DestinationAirportCode].servedCityName;
        var slice2OriginServedCityName = airportMap[slice2OriginAirportCode].servedCityName;
        var slice2DestinationServedCityName = airportMap[slice2DestinationAirportCode].servedCityName;
        var matchedCities = slice1OriginServedCityName === slice2DestinationServedCityName &&
            slice1DestinationServedCityName === slice2OriginServedCityName;
        return !matchedCities;
    }
    return true;
};
export var getUniqueCitiesFromTripSlices = function (slices, airportMap) {
    var allLocations = slices.reduce(function (locations, slice) {
        var firstSegment = slice.segments[0];
        var lastSegment = slice.segments[slice.segments.length - 1];
        var originCity = airportMap[firstSegment.origin.locationCode].servedCityName;
        var destinationCity = airportMap[lastSegment.destination.locationCode].servedCityName;
        return locations.concat([originCity, destinationCity]);
    }, []);
    return uniq(allLocations);
};
export var getTruncatedCityList = function (cities) {
    var firstThree = cities.slice(0, 3);
    return firstThree.join(", ") + (cities.length > 3 ? "..." : "");
};
export var getFlightInfoDetails = function (locators, departureSlice, returnSlice, formatDate, airports, airlines) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    // Gets the last segment to avoid using the layover destinationCode
    var departureLastSegmentIndex = departureSlice
        ? departureSlice.segments.length - 1
        : 0;
    var departureDestinationSegment = departureSlice
        ? departureSlice.segments[departureLastSegmentIndex]
        : undefined;
    var destinationCode = (_a = departureDestinationSegment === null || departureDestinationSegment === void 0 ? void 0 : departureDestinationSegment.destination.locationCode) !== null && _a !== void 0 ? _a : "";
    var firstLegDeparture = departureSlice === null || departureSlice === void 0 ? void 0 : departureSlice.segments[0];
    var firstLegReturn = returnSlice ? returnSlice.segments[0] : null;
    var originCode = (_b = firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.origin.locationCode) !== null && _b !== void 0 ? _b : "";
    var airlineCode = (_c = firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.marketingAirline.code) !== null && _c !== void 0 ? _c : "";
    return {
        title: "".concat(((_d = airports[originCode]) === null || _d === void 0 ? void 0 : _d.cityName) || originCode, " to ").concat(((_e = airports[destinationCode]) === null || _e === void 0 ? void 0 : _e.cityName) || destinationCode),
        confirmationCode: "H-".concat(locators === null || locators === void 0 ? void 0 : locators.agent.unscopedValue),
        startDate: formatDate((_f = firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.scheduledDeparture) !== null && _f !== void 0 ? _f : ""),
        endDate: firstLegReturn
            ? formatDate(firstLegReturn.scheduledDeparture)
            : "",
        subtitle: returnSlice ? "Round-trip" : "One-way",
        airlineCode: airlineCode,
        airlineName: ((_h = airlines[(_g = firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.marketingAirline.code) !== null && _g !== void 0 ? _g : ""]) === null || _h === void 0 ? void 0 : _h.displayName) ||
            airlineCode,
        flightNumber: airlineCode +
            " " +
            (firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.marketingAirline.flightNumber.toString()),
    };
};
export var getMulticityFlightInfoDetails = function (bookedItinerary, formatDate, airports, airlines) {
    var _a, _b, _c, _d, _e;
    var travelItinerary = bookedItinerary.travelItinerary;
    var tripSlices = getSlicesFromTravelItinerary(travelItinerary);
    var uniqueCityNames = getUniqueCitiesFromTripSlices(tripSlices, airports);
    var title = getTruncatedCityList(uniqueCityNames);
    var lastSlice = tripSlices[tripSlices.length - 1];
    var firstLegDeparture = tripSlices[0].segments[0];
    var lastLegReturn = lastSlice.segments[lastSlice.segments.length - 1];
    var airlineCode = (_a = firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.marketingAirline.code) !== null && _a !== void 0 ? _a : "";
    return {
        title: title,
        confirmationCode: "H-".concat((_b = travelItinerary === null || travelItinerary === void 0 ? void 0 : travelItinerary.locators) === null || _b === void 0 ? void 0 : _b.agent.unscopedValue),
        startDate: formatDate((_c = firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.scheduledDeparture) !== null && _c !== void 0 ? _c : ""),
        endDate: formatDate(lastLegReturn.scheduledDeparture),
        subtitle: "Multi-city",
        airlineCode: airlineCode,
        airlineName: ((_e = airlines[(_d = firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.marketingAirline.code) !== null && _d !== void 0 ? _d : ""]) === null || _e === void 0 ? void 0 : _e.displayName) ||
            airlineCode,
        flightNumber: airlineCode +
            " " +
            (firstLegDeparture === null || firstLegDeparture === void 0 ? void 0 : firstLegDeparture.marketingAirline.flightNumber.toString()),
    };
};
var getJetBluePenaltyInfo = function (penalty, penaltyName, brandName) {
    switch (brandName) {
        case "Blue":
        case "Blue Plus":
        case "Blue Extra":
        case "Mint":
            return {
                name: penaltyName,
                description: penaltyName === CANCELLATIONS ? "Cancel for a credit" : "Free",
                symbol: ShopSymbol.INCLUDED,
            };
        case "Blue Ref":
        case "Blue Plus Ref":
        case "Blue Extra Ref":
        case "Mint Ref":
            return {
                name: penaltyName,
                description: "Free",
                symbol: ShopSymbol.INCLUDED,
            };
        default:
            return getPenaltyInfo(penalty, penaltyName);
    }
};
var isJetBlueFromBrand = function (brandName) {
    switch (brandName) {
        case "Blue Basic":
        case "Blue":
        case "Blue Ref":
        case "Blue Plus":
        case "Blue Plus Ref":
        case "Blue Extra":
        case "Blue Extra Ref":
        case "Mint":
        case "Mint Ref":
            return true;
        default:
            return false;
    }
};
export var getCombinedRestrictionInfo = function (flightRestrictionInfo, sliceRestricionInfo, isTF, brandName) {
    if (isTF === void 0) { isTF = false; }
    var restrictions = [];
    var baggageRestrictionInfo = sliceRestricionInfo &&
        (sliceRestricionInfo === null || sliceRestricionInfo === void 0 ? void 0 : sliceRestricionInfo.baggageInfo.BaggageInfo) != BaggageInfoEnum.NotAllowed
        ? sliceRestricionInfo
        : flightRestrictionInfo;
    switch (baggageRestrictionInfo === null || baggageRestrictionInfo === void 0 ? void 0 : baggageRestrictionInfo.baggageInfo.BaggageInfo) {
        case BaggageInfoEnum.Allowed:
            var info = baggageRestrictionInfo.baggageInfo;
            if (info.allowance.pieces > 0 && info.allowance.descriptions.length > 0) {
                restrictions.push({
                    name: "",
                    description: info.allowance.descriptions.join(" "),
                    symbol: ShopSymbol.INCLUDED,
                });
            }
            if (info.charges.length > 0) {
                restrictions.push({
                    name: "Checked bag allowance",
                    symbol: ShopSymbol.PURCHASABLE,
                    description: info.charges.reduce(function (prev, curr, index, charges) {
                        var string = "Bag ".concat(curr.firstPiece, " at $").concat(curr.amount, " ").concat(curr.currency);
                        if (index < charges.length - 1) {
                            string += ", ";
                        }
                        return (prev += string);
                    }, ""),
                });
            }
            break;
        case BaggageInfoEnum.NotAllowed:
            restrictions.push({
                name: "Checked bag allowance",
                symbol: ShopSymbol.PURCHASABLE,
                description: "Not allowed",
            });
            break;
        case BaggageInfoEnum.Unknown:
            break;
        default:
            break;
    }
    var penaltiesRestrictionInfo = (sliceRestricionInfo === null || sliceRestricionInfo === void 0 ? void 0 : sliceRestricionInfo.penaltiesInfo.PenaltiesInfo) !=
        PenaltiesInfoEnum.Unknown
        ? sliceRestricionInfo
        : flightRestrictionInfo;
    switch (penaltiesRestrictionInfo === null || penaltiesRestrictionInfo === void 0 ? void 0 : penaltiesRestrictionInfo.penaltiesInfo.PenaltiesInfo) {
        case PenaltiesInfoEnum.Known:
            var info = penaltiesRestrictionInfo === null || penaltiesRestrictionInfo === void 0 ? void 0 : penaltiesRestrictionInfo.penaltiesInfo;
            if (isJetBlueFromBrand(brandName)) {
                restrictions.push(getJetBluePenaltyInfo(info.cancelPenalty, CANCELLATIONS, brandName));
                restrictions.push(getJetBluePenaltyInfo(info.changePenalty, EXCHANGES, brandName));
            }
            else {
                restrictions.push(getPenaltyInfo(info.cancelPenalty, CANCELLATIONS));
                restrictions.push(getPenaltyInfo(info.changePenalty, EXCHANGES));
            }
            break;
        case PenaltiesInfoEnum.ExternallyManaged:
        case PenaltiesInfoEnum.Unknown:
            restrictions.push({
                name: CANCELLATIONS,
                description: isTF
                    ? "Click 'Cancel Flight' above to view eligibility"
                    : "Contact airline",
                symbol: ShopSymbol.UNKNOWN,
            });
            break;
        default:
            break;
    }
    return restrictions;
};
export var CANCELLATIONS = "Cancellations";
export var EXCHANGES = "Exchanges";
export var getRestrictionInfo = function (flight, isTF, slice, brandName) {
    if (isTF === void 0) { isTF = false; }
    var flightRestrictionInfo = flight.bookedItinerary.restrictions;
    var sliceRestricionInfo = slice === null || slice === void 0 ? void 0 : slice.restrictions;
    return getCombinedRestrictionInfo(flightRestrictionInfo, sliceRestricionInfo, isTF, brandName);
};
var getPenaltyInfo = function (penalty, name) {
    switch (penalty.Penalty) {
        case PenaltyEnum.WithFee:
            var info = penalty;
            return {
                name: name,
                description: "for a fee of $".concat(info.amount, " ").concat(info.currency),
                symbol: ShopSymbol.PURCHASABLE,
            };
        case PenaltyEnum.Unknown:
            return {
                name: name,
                description: "Contact support",
                symbol: ShopSymbol.UNAVAILABLE,
            };
        case PenaltyEnum.NotPossible:
            return {
                name: name,
                description: "Non-refundable",
                symbol: ShopSymbol.UNAVAILABLE,
            };
        case PenaltyEnum.NoPenalty:
            return {
                name: name,
                description: "Free",
                symbol: ShopSymbol.INCLUDED,
            };
    }
};
export var getDurationFromSegments = function (segments, getTimeDiff) {
    var departureSeg = segments[0];
    var arrivalSeg = segments[segments.length - 1];
    var departureTime = departureSeg.zonedUpdatedDeparture ||
        departureSeg.zonedScheduledDeparture ||
        departureSeg.scheduledDeparture;
    var arrivalTime = arrivalSeg.zonedUpdatedArrival ||
        arrivalSeg.zonedScheduledArrival ||
        arrivalSeg.scheduledArrival;
    return getTimeDiff(departureTime, arrivalTime);
};
export var getStopsFromSegments = function (segments) {
    if (segments === void 0) { segments = []; }
    return segments.length ? segments.length - 1 : 0;
};
export var getSegmentCounts = function (itinerary) {
    var _a;
    return {
        outboundFlight: getDepartureSliceFromTravelItinerary(itinerary).segments.length,
        returnFlight: (_a = getReturnSliceFromTravelItinerary(itinerary)) === null || _a === void 0 ? void 0 : _a.segments.length,
    };
};
export var getSegmentStopCounts = function (itinerary) {
    var _a = getSegmentCounts(itinerary), outboundFlight = _a.outboundFlight, returnFlight = _a.returnFlight;
    return {
        outboundFlight: outboundFlight - 1,
        returnFlight: returnFlight ? returnFlight - 1 : undefined,
    };
};
export var getCurrencyPrefix = function (flight) {
    var sellingPricing = flight.bookedItinerary.sellingPricing;
    return "".concat(sellingPricing.totalPricing.currency, " ").concat(sellingPricing.totalPricing.baseWithoutMargin.fiat.currencySymbol);
};
export var getPriceWithDecimal = function (flight) {
    var _a, _b, _c;
    var total = flight.bookedItinerary.sellingPricing.totalPricing.total;
    // `total` excludes seat-selection cost (seats are priced separately in
    // `bookedItinerary.seats`), so add it in to get the true trip total.
    var seatsTotal = (_c = (_b = (_a = flight.bookedItinerary.seats) === null || _a === void 0 ? void 0 : _a.seats) === null || _b === void 0 ? void 0 : _b.reduce(function (acc, seat) { return acc + seat.price; }, 0)) !== null && _c !== void 0 ? _c : 0;
    return (total.fiat.value + seatsTotal).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
export var BookingType;
(function (BookingType) {
    BookingType["Experiences"] = "Experiences";
    BookingType["Activities"] = "Activities";
    BookingType["Flight"] = "Flight";
    BookingType["Ground"] = "Ground";
    BookingType["Homes"] = "Homes";
    BookingType["Lodging"] = "Lodging";
    BookingType["Package"] = "Package";
})(BookingType || (BookingType = {}));
export var getAllSlicesFromTravelItinerary = function (travelItinerary) {
    switch (travelItinerary === null || travelItinerary === void 0 ? void 0 : travelItinerary.TravelItinerary) {
        case TravelItineraryEnum.SingleTravelItinerary:
            return travelItinerary.slices;
        case TravelItineraryEnum.MultiTravelItinerary:
            return travelItinerary.travelItineraries.flatMap(function (i) { return i.slices; });
    }
};
//# sourceMappingURL=itinerary.js.map